import { apiClient } from './apiClient';

export const processService = {
    createCessao: async (cpf, processoId = null, percentual = 100.0) => {
        const response = await apiClient.post('/cedentes/cessao', {
            cpf: cpf,
            processo_id: processoId,
            percentual: percentual
        });
        return response.data;
    },

    getProcessos: async () => {
        const response = await apiClient.get('/processos');
        return response.data;
    },

    createProcesso: async (data) => {
        const response = await apiClient.post('/processos', data);
        return response.data;
    },

    updateProcesso: async (id, data) => {
        const response = await apiClient.put(`/processos/${id}`, data);
        return response.data;
    },

    deleteProcesso: async (id) => {
        const response = await apiClient.delete(`/processos/${id}`);
        return response.data;
    },

    addProcessoDocumento: async (processoId, data) => {
        const response = await apiClient.post(`/processos/${processoId}/documentos`, data);
        return response.data;
    },

    updateProcessoDocumento: async (processoId, docId, data) => {
        const response = await apiClient.put(`/processos/${processoId}/documentos/${docId}`, data);
        return response.data;
    },

    removeProcessoDocumento: async (processoId, docId) => {
        const response = await apiClient.delete(`/processos/${processoId}/documentos/${docId}`);
        return response.data;
    },

    addProcessoSigner: async (processoId, data) => {
        const response = await apiClient.post(`/processos/${processoId}/signers`, data);
        return response.data;
    },

    removeProcessoSigner: async (processoId, signerId) => {
        const response = await apiClient.delete(`/processos/${processoId}/signers/${signerId}`);
        return response.data;
    },

    updateProcessoSigner: async (processoId, signerId, data) => {
        const response = await apiClient.put(`/processos/${processoId}/signers/${signerId}`, data);
        return response.data;
    },

    getProcessoCedentes: async (processoId, search = "", limit = 50, offset = 0, tipoAceite = null, status = null, tranche = null) => {
        const params = new URLSearchParams({ limit, offset });
        if (search) params.append("search", search);
        if (tipoAceite) params.append("tipo_aceite", tipoAceite);
        if (status) params.append("status", status);
        if (tranche) params.append("tranche", tranche);
        const response = await apiClient.get(`/processos/${processoId}/cedentes?${params.toString()}`);
        return response.data;
    },

    getTranches: async (processoId) => {
        const response = await apiClient.get(`/processos/${processoId}/tranches`);
        return response.data;
    },

    assignTranche: async (processoId, cedenteIds, tranche) => {
        const response = await apiClient.post(`/processos/${processoId}/cedentes/tranche`, {
            cedente_ids: cedenteIds,
            tranche,
        });
        return response.data;
    },

    exportProcessoCedentesCSV: async (processoId) => {
        const response = await apiClient.get(`/processos/${processoId}/cedentes/export`, { responseType: "blob" });
        return response.data;
    },

    exportProcessoCedentesXLSX: async (processoId, columns) => {
        const params = columns && columns.length ? { columns: columns.join(",") } : {};
        const response = await apiClient.get(`/processos/${processoId}/cedentes/export-xlsx`, { responseType: "blob", params });
        return response.data;
    },

    linkCedentesBulk: async (processoId, payload) => {
        const response = await apiClient.post(`/processos/${processoId}/cedentes/bulk`, payload);
        return response.data;
    },

    linkCedente: async (processoId, payload) => {
        const response = await apiClient.post(`/processos/${processoId}/cedentes`, payload);
        return response.data;
    },

    unlinkCedente: async (processoId, cedenteId) => {
        const response = await apiClient.delete(`/processos/${processoId}/cedentes/${cedenteId}`);
        return response.data;
    },

    importCedentesXLSX: async (processoId, file, criarSeNaoExistir = false, resetarAssinados = false, definirAtivo = null) => {
        const formData = new FormData();
        formData.append("file", file);
        const params = new URLSearchParams({ criar_se_nao_existir: criarSeNaoExistir });
        if (resetarAssinados) params.set("resetar_assinados", "true");
        if (definirAtivo !== null) params.set("definir_ativo", String(definirAtivo));
        const response = await apiClient.post(
            `/processos/${processoId}/cedentes/import-xlsx?${params.toString()}`,
            formData
        );
        return response.data;
    },

    unlinkCedentesBulk: async (processoId, cedenteIds) => {
        const response = await apiClient.delete(`/processos/${processoId}/cedentes/bulk`, {
            data: { cedente_ids: cedenteIds }
        });
        return response.data;
    },

    checkDeletedLink: async (processoId, cedenteId) => {
        const response = await apiClient.get(`/processos/${processoId}/cedentes/${cedenteId}/check-deleted`);
        return response.data;
    },

    getDashboardStats: async (processoId) => {
        const response = await apiClient.get(`/processos/${processoId}/dashboard`);
        return response.data;
    },

    getDashboardStatsBatch: async (processoIds) => {
        const params = new URLSearchParams();
        processoIds.forEach((id) => params.append("processo_ids", id));
        const response = await apiClient.get(`/dashboard/stats/batch?${params.toString()}`);
        return response.data;
    },

    bulkStatusUpdate: async (file, processoId = null) => {
        const formData = new FormData();
        formData.append('file', file);

        let url = '/processos/status-bulk';
        if (processoId) {
            url += `?processo_id=${processoId}`;
        }

        const response = await apiClient.post(url, formData);
        return response.data;
    },

    registerManualSignature: async (processoId, data) => {
        const response = await apiClient.post(`/processos/${processoId}/assinaturas-manuais`, data);
        return response.data;
    },

    listManualSignatures: async (processoId) => {
        const response = await apiClient.get(`/processos/${processoId}/assinaturas-manuais`);
        return response.data;
    },

    deleteManualSignature: async (processoId, assId) => {
        const response = await apiClient.delete(`/processos/${processoId}/assinaturas-manuais/${assId}`);
        return response.data;
    },

    syncCedenteEnvelope: async (processoId, cedenteId, envelopeKey = null) => {
        const response = await apiClient.post(`/clicksign/sync-envelope/${processoId}/${cedenteId}`, { envelope_key: envelopeKey || null });
        return response.data;
    },

    importManualSignatures: async (processoId, file) => {
        const formData = new FormData();
        formData.append("file", file);
        const response = await apiClient.post(`/processos/${processoId}/assinaturas-manuais/import`, formData);
        return response.data;
    },

    toggleCedenteAtivo: async (cedenteId) => {
        const response = await apiClient.patch(`/cedentes/${cedenteId}/toggle-active`);
        return response.data;
    },

    bulkSetAtivoByIds: async (cedenteIds, ativo) => {
        const response = await apiClient.patch('/cedentes/bulk-ativo', { cedente_ids: cedenteIds, ativo });
        return response.data;
    },

    toggleCedenteFalecido: async (cedenteId) => {
        const response = await apiClient.patch(`/cedentes/${cedenteId}/toggle-falecido`);
        return response.data;
    },

    toggleCedentePendenteDocumentacao: async (cedenteId) => {
        const response = await apiClient.patch(`/cedentes/${cedenteId}/toggle-pendente-documentacao`);
        return response.data;
    },

    toggleProcessoCedenteRecalculo: async (processoId, cedenteId) => {
        const response = await apiClient.patch(`/processos/${processoId}/cedentes/${cedenteId}/toggle-recalculo`);
        return response.data;
    },

    getHerdeirosByCedente: async (cedenteId) => {
        const response = await apiClient.get(`/cedentes/${cedenteId}/herdeiros`);
        return response.data;
    },

    createHerdeiro: async (cedenteId, data) => {
        const response = await apiClient.post(`/cedentes/${cedenteId}/herdeiros`, data);
        return response.data;
    },

    updateHerdeiro: async (cedenteId, herdeiroId, data) => {
        const response = await apiClient.put(`/cedentes/${cedenteId}/herdeiros/${herdeiroId}`, data);
        return response.data;
    },

    deleteHerdeiro: async (cedenteId, herdeiroId) => {
        await apiClient.delete(`/cedentes/${cedenteId}/herdeiros/${herdeiroId}`);
    },

    getHerdeirosByProcesso: async (processoId) => {
        const response = await apiClient.get(`/processos/${processoId}/herdeiros`);
        return response.data;
    },

    downloadTemplateCedentes: async (processoId) => {
        const response = await apiClient.get(`/processos/${processoId}/cedentes/template-cedentes`, { responseType: "blob" });
        return response.data;
    },

    downloadTemplatePropostas: async (processoId) => {
        const response = await apiClient.get(`/processos/${processoId}/cedentes/template-propostas`, { responseType: "blob" });
        return response.data;
    },

    downloadTemplateAssinaturasManuais: async (processoId) => {
        const response = await apiClient.get(`/processos/${processoId}/cedentes/template-assinaturas-manuais`, { responseType: "blob" });
        return response.data;
    },

    updateDocumentoSigners: async (processoId, docId, signerIds) => {
        const response = await apiClient.put(`/processos/${processoId}/documentos/${docId}/signers`, { signer_ids: signerIds });
        return response.data;
    },
};
